import { getI18nInstance } from '@wkda/funnel-components';
import { messages } from '../translations/wkda-sf/de-at/messages.mjs';

export async function activate() {}

export function initializeI18n(locale, i18n = getI18nInstance()) {
  i18n.load(locale, messages);
  i18n.activate(locale);
}
